import { SEM_TYPOGRAPHY_FORMS_CAPTION, SEM_TYPOGRAPHY_FORMS_INPUT, SEM_TYPOGRAPHY_FORMS_LABEL } from '../../tokens/typography.generated.js';
import { getTypographyStyles } from '../../utils/get-typography-styles/index.js';
import styled from 'styled-components';
import { SYS_SIZE_FIXED_100, SYS_SIZE_FIXED_1800, SYS_SIZE_FIXED_300 } from '../../tokens/sizing.generated.js';
import { SYS_SPACE_FIXED_100, SYS_SPACE_FIXED_150 } from '../../tokens/spacing.generated.js';
export const StyledTextAreaOuter = styled.div `
  display: flex;
  padding: ${SYS_SPACE_FIXED_150};

  // TODO: token missing
  transition-timing-function: cubic-bezier(0.75, 0.02, 0.5, 1);
  transition-duration: 250ms;
  transition-property: box-shadow, color;

  box-shadow: inset 0 0 0 1px
    ${(props) => props.invalid
    ? props.theme.sem.color.forms.surface.underline.stroke.error
    : props.theme.sem.color.forms.surface.underline.stroke.default};

  &:has(textarea:hover:not(:disabled)) {
    box-shadow: inset 0 0 0 1px
      ${(props) => props.invalid
    ? props.theme.sem.color.forms.surface.underline.stroke.error
    : props.theme.sem.color.forms.surface.underline.stroke.interactive};
  }

  &:has(textarea:active:not(:disabled)) {
    box-shadow:
      inset 0 0 0 1px
        ${(props) => props.invalid
    ? props.theme.sem.color.forms.surface.underline.stroke.error
    : props.theme.sem.color.forms.surface.underline.stroke.interactive},
      inset 0 -2px 0 0 ${(props) => (props.invalid ? props.theme.sem.color.forms.surface.underline.stroke.error : props.theme.sem.color.forms.surface.underline.stroke.interactive)};
  }

  &:has(textarea:disabled) {
    cursor: not-allowed;
    box-shadow: inset 0 0 0 1px
      ${(props) => props.theme.sem.color.forms.surface.underline.stroke.disabled};
  }
`;
export const StyledTextArea = styled.textarea `
  background-color: transparent;
  min-height: ${SYS_SIZE_FIXED_1800};
  flex: 1 0 auto;
  appearance: none;
  box-sizing: border-box;
  color: ${(props) => props.theme.sem.color.forms.foreground.text.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_INPUT)}
  width: 100%;
  resize: vertical;
  border: none;

  &:disabled {
    cursor: not-allowed;
    color: ${(props) => props.theme.sem.color.forms.foreground.text.disabled};
  }

  &::placeholder {
    color: ${(props) => props.theme.sem.color.forms.foreground.text.caption};
  }
`;
export const StyledTextAreaContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
export const StyledLabel = styled.label `
  display: flex;
  align-items: baseline;
  color: ${(props) => props.disabled
    ? props.theme.sem.color.forms.foreground.text.disabled
    : props.invalid
        ? props.theme.sem.color.forms.foreground.text.error
        : props.theme.sem.color.forms.foreground.text.default};
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_LABEL)}
  gap: ${SYS_SIZE_FIXED_100};
  margin-bottom: ${SYS_SPACE_FIXED_100};
`;
export const StyledAdditionalContent = styled.div `
  padding-top: ${SYS_SIZE_FIXED_300};
  display: flex;
  gap: ${SYS_SPACE_FIXED_100};
  justify-content: ${(props) => props.hasHintMessages ? 'space-between' : 'flex-end'};
  align-items: flex-start;
`;
export const StyledHintMessages = styled.div `
  gap: ${SYS_SIZE_FIXED_300};
  display: flex;
  flex-direction: column;
`;
export const StyledCharacterCount = styled.div `
  flex-shrink: 0;
  ${getTypographyStyles(SEM_TYPOGRAPHY_FORMS_CAPTION)}
  color: ${(props) => props.theme.sem.color.forms.foreground.text.caption}
`;
//# sourceMappingURL=index.styles.js.map